import { useState, useEffect } from "react"; //library
import { useNavigate } from "react-router-dom"; //React Router DOM library.


export default function Searchpage({allsigns,setAllsigns}) {
  const [zodiac, setZodiac] = useState("");  // zodaic gets changed to set zodiac - by usestate - now lets me "change" each sign on the page
  const navigate = useNavigate();
  
    useEffect(() => { // an empty dependency use effect so the page only renders it once, nothing will happen if it changes
    fetch("https://us-central1-zodiacwebbe.cloudfunctions.net/api/data") //hits my api - gets my raw data (grabbed by my fetch)
     .then((resp) => resp.json()) // gets all my data from the response body from json body and returns what exactly i need.
     .then((data) => setAllsigns(data)) //that parsed data is now called setallsigns 
      .catch(alert); // if something goes wrong, you get an alert
   }, [setAllsigns]); 

  const token = localStorage.getItem("token"); //grabs a token from localstorage for memory

  const handleSearchpage = (e) => {
    e.preventDefault(); //prevents the form from sending random data to the api - instead sends in our code.
    navigate("/" + zodiac);
  };

  return (
    <>
    
      <form onSubmit={handleSearchpage}>
        <h2> ⋆｡°✩Enter*:･ﾟ</h2>
        <label htmlFor="zodiac">
          Zodiac: &nbsp;

          <select onChange={(e) => {
              setZodiac(e.target.value);
            }}>
            <option>choose a sign</option>
            {allsigns && allsigns.map(sign=>(              
              <option key={sign["id"]}> {sign.sign} </option>
            ))}
          </select> 
        </label>
        <br />
        <br />

   
       
            <button className='button'type="submit" >Submit</button>
      </form>
    </>
  );
}
